 <template>
  <div>
    <vs-popup
      class="container-appendix-popup"
      :title="inputs.name.value + ' 登録'"
      :active.sync="popupActive"
    >
      <vs-row class="flame" vs-w="12" type="flex">
        <vs-col class="input-group" vs-lg="6" vs-sm="6" vs-xs="12" type="flex">
          <vs-row class="left-group" vs-w="12" type="flex">
            <vs-col
              class="input-col"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <div class="string-input">
                <vs-input
                  :label="inputs.serialNumber.label"
                  class="serial_number-input w-full"
                  :color="AISEA_COLOR.BLUE"
                  v-validate="'max:12'"
                  name="serialNumber"
                  data-vv-as="コンテナ番号"
                  v-model="inputs.serialNumber.value"
                ></vs-input>
                <span class="text-danger text-sm" v-show="errors.has('serialNumber')">{{
                  errors.first("serialNumber")
                }}</span>
              </div>
            </vs-col>

            <vs-col
              class="input-col"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <div class="string-input">
                <vs-input
                  :label="inputs.cargo.label"
                  class="cargo-input w-full"
                  :color="AISEA_COLOR.BLUE"
                  v-model="inputs.cargo.value"
                ></vs-input>
              </div>
            </vs-col>

            <vs-col
              class="input-col"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <div class="string-input">
                <vs-input
                  :label="inputs.type.label"
                  class="type-input w-full"
                  :color="AISEA_COLOR.BLUE"
                  v-model="inputs.type.value"
                ></vs-input>
              </div>
            </vs-col>

            <vs-col
              class="input-col"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <div class="string-input">
                <vs-input
                  :label="inputs.presetTemperature.label"
                  class="preset_temperature-input w-full"
                  :color="AISEA_COLOR.BLUE"
                  v-model="inputs.presetTemperature.value"
                ></vs-input>
              </div>
            </vs-col>
          </vs-row>
        </vs-col>

        <vs-col class="input-group" vs-lg="6" vs-sm="6" vs-xs="12" type="flex">
          <vs-row class="right-group" vs-w="12" type="flex">
            <vs-col
              class="input-col"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <div class="select-input">
                <span class="select-input-label aisea-text-14-400-black">{{
                  inputs.customer.label
                }}</span>
                <v-select
                  label="name"
                  class="customer-select"
                  :options="customers"
                  outlined
                  v-model="inputs.customer.value"
                ><template slot="no-options">顧客情報が見つかりませんでした。</template></v-select>
              </div>
            </vs-col>

            <vs-col
              class="input-col"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <div class="string-input">
                <vs-input
                  :label="inputs.personInCharge.label"
                  class="person_in_charge-input w-full"
                  :color="AISEA_COLOR.BLUE"
                  v-model="inputs.personInCharge.value"
                ></vs-input>
              </div>
            </vs-col>

            <vs-col
              class="input-col"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <div class="string-input">
                <vs-input
                  :label="inputs.tel.label"
                  class="tel-input w-full"
                  :color="AISEA_COLOR.BLUE"
                  v-model="inputs.tel.value"
                ></vs-input>
              </div>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>

      <vs-row class="button-area" vs-w="12" type="flex">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-lg="3"
          vs-sm="3"
          vs-xs="6"
        >
          <vs-button
            class="action-button aisea-text-14-400-white"
            :color="AISEA_COLOR.SLIGHTLY_GRAY"
            @click="cancelEdit"
            >キャンセル</vs-button
          >
        </vs-col>

        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-lg="3"
          vs-sm="3"
          vs-xs="6"
        >
          <vs-button
            class="action-button aisea-text-14-400-white"
            :color="AISEA_COLOR.BLUE"
            @click="updateData"
            >保存</vs-button
          >
        </vs-col>

        <vs-col
          vs-type="flex"
          :vs-justify=" getDeviceInfo().deviceType === 'iPhone' && getDeviceInfo().deviceOrientation === 'portrait' ? 'flex-start' : 'flex-end' "
          vs-align="center"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
        >
          <vs-button
            class="action-button aisea-text-14-400-blue order-button top-button flat-button"
            color="#ffffff"
            @click="alertDelete"
          >
            <div class="button-inner">入力内容クリア</div>
          </vs-button>
        </vs-col>
      </vs-row>
      <error-dialog ref="errorDialog"></error-dialog>
    </vs-popup>
    <vs-popup
      class="basic-master-popup"
      title="コンテナ情報の削除"
      :active.sync="deletePopActive"
    >
      <p class="aisea-text-14-400-black">
        「{{ inputs.name.value }}」のコンテナ情報を削除してよろしいですか？
      </p>
      <div class="button-area">
        <vs-button
          class="aisea-text-14-400-white action-button"
          :color="AISEA_COLOR.SLIGHTLY_GRAY"
          @click="cancelEdit"
          >キャンセル</vs-button
        >
        <vs-button
          class="aisea-text-14-400-white action-button"
          :color="AISEA_COLOR.BLUE"
          @click="callDelete"
          >削除</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from "vue-select";
import ErrorDialog from "../../components/ErrorDialog";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("ecoShip");
import { DeviceInfoMixin, ColorMixin } from "@/mixins";

export default {
  components: {
    vSelect,
    ErrorDialog,
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  props: {
    customers: { type: Array },
  },
  created() {},
  data() {
    return {
      enterprise_vessel_id: "",
      customersList: [],
      inputs: {
        id: {
          label: "ID",
          value: null,
          originalValue: null,
        },
        name: {
          label: "名前",
          value: null,
          originalValue: null,
        },
        serialNumber: {
          label: "コンテナ番号",
          value: null,
          originalValue: null,
        },
        cargo: {
          label: "積荷",
          value: null,
          originalValue: null,
        },
        type: {
          label: "種類",
          value: null,
          originalValue: null,
        },
        presetTemperature: {
          label: "設定温度",
          value: null,
          originalValue: null,
        },
        customer: {
          label: "顧客名",
          value: null,
          originalValue: null,
        },
        personInCharge: {
          label: "担当者",
          value: null,
          originalValue: null,
        },
        tel: {
          label: "電話番号",
          value: null,
          originalValue: null,
        },
      },
      popupActive: false,
      deletePopActive: false,
    };
  },
  watch: {
    "inputs.customer.value": {
      handler: function (afterValue, beforeValue) {
        this.updateCustomerValue(afterValue, beforeValue);
      },
    },
  },
  methods: {
    ...mapActions([
      "fetchContainerCustomers",
      "updateVesselContainers",
      "deleteVesselContainers",
    ]),
    openEditDialog(enterprise_vessel_id, data) {
      this.enterprise_vessel_id = enterprise_vessel_id;
      this.popupActive = true;
      this.inputs.id.value = data.id;
      this.inputs.name.value = data.name;
      if (data.appendix != null) {
        this.inputs.serialNumber.value = data.appendix.serial_number;
        this.inputs.cargo.value = data.appendix.cargo;
        this.inputs.type.value = data.appendix.type;
        this.inputs.presetTemperature.value = data.appendix.preset_temperature;
        this.inputs.personInCharge.value = data.appendix.person_in_charge;
        this.inputs.tel.value = data.appendix.tel;

        if (data.appendix.customer !== null) {
          this.inputs.customer.value = data.appendix.customer;
        } else {
          this.inputs.customer.value = null;
        }
      } else {
        this.inputs.serialNumber.value = null;
        this.inputs.cargo.value = null;
        this.inputs.type.value = null;
        this.inputs.presetTemperature.value = null;
        this.inputs.personInCharge.value = null;
        this.inputs.tel.value = null;
        this.inputs.customer.value = null;

      }

      Object.keys(this.inputs).forEach((key) => {
        this.inputs[key].originalValue = this.inputs[key].value;
      });
    },
    cancelEdit() {
      this.deletePopActive = false;
      this.popupActive = false;
      Object.keys(this.inputs).forEach((key) => {
        this.inputs[key].value = this.inputs[key].originalValue;
      });
    },
    updateCustomerValue(afterValue, _beforeValue) {
      if (afterValue != null) {
        this.inputs.customer.value = afterValue;
        if( this.inputs.personInCharge.value == null || this.inputs.personInCharge.value == '' ){
          this.inputs.personInCharge.value = afterValue.person_in_charge;
        }
        if( this.inputs.tel.value == null || this.inputs.tel.value == '' ){
          this.inputs.tel.value = afterValue.tel;
        }
      }
    },
    async updateData() {
      let serialNumber = this.inputs.serialNumber.value;
      let cargo = this.inputs.cargo.value;
      let type = this.inputs.type.value;
      let presetTemperature = this.inputs.presetTemperature.value;
      let customer_id = this.inputs.customer.value === null ? null : this.inputs.customer.value.id;
      let personInCharge = this.inputs.personInCharge.value;
      let tel = this.inputs.tel.value;

      let payload = {
        id: this.enterprise_vessel_id,
        container_id: this.inputs.id.value,
        body: {
          appendix: {
            serial_number: serialNumber,
            cargo: cargo,
            type: type,
            preset_temperature: presetTemperature,
            customer_id: customer_id,
            person_in_charge: personInCharge,
            tel: tel,
          },
        },
      };
      try {
        await this.updateVesselContainers(payload);
        this.$vs.notify({
          title: "データを保存しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-center",
        });
        this.popupActive = false;
        this.$vs.loading.close();
        this.$emit("refresh");
      } catch (error) {
        if (error.code == "422") {
          let validationErrors = error.data.validation_results.map((element) => {
            let target = element.target.split(/\./);
            let label = this.inputs[target[1]].label;
            let message = element.message;
            return {
              label: label,
              message: message,
            };
          });
          this.$refs.errorDialog.open("エラー", null, validationErrors);
        } else {
          this.$refs.errorDialog.open("エラー", error.message, null);
        }
      }
    },
    alertDelete() {
      this.popupActive = false;
      this.deletePopActive = true;
    },
    async callDelete() {
      this.deletePopActive = false;
      let payload = {
        id: this.enterprise_vessel_id,
        container_id: this.inputs.id.value,
      };
      try {
        this.$vs.loading();
        await this.deleteVesselContainers(payload);
        this.$vs.notify({
          title: "データを削除しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-center",
        });
        this.$emit("refresh");
      } catch (e) {
        this.$vs.notify({
          title: "データを削除できませんでした。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
.container-appendix-popup {
  .select-input {
    margin-bottom: 1.1rem;
    margin-left: 8px;
    margin-right: 8px;
    width:100%;
    .customer-select {
      .vs__dropdown-toggle{
        height: 2.6rem;
      }
    }
    .select-input-label {
      padding-left: 0.4rem;
    }
  }
  .string-input {
    margin-bottom: 1rem;
    margin-left: 8px;
    margin-right: 8px;
    width:100%;
  }
  .vs-input--label {
    font-size: 14px;
    font-family: $aisea-font-family;
    font-weight: 400;
    color: $aisea-black;
  }
  .action-button {
    margin-left: 10px;
    margin-bottom: 0.6rem;
  }
  .button-area {
    width: fit-content;
    margin-top: 20px;
    margin-left: auto;
  }
  .top-button {
    height: 42px;
  }
  .border-button {
    border: solid 1px $aisea-blue;
    .button-inner {
      line-height: 1;
    }
  }
  .button-area {
    .action-button {
      margin: 8px;
    }
  }
  .flat-button {
    padding-left:  0.2rem !important;
    padding-right: 0.5rem !important;
  }
  .more-button-dropdown {
    width: 90px;
  }
  .vs__dropdown-toggle {
    height: 4rem;
  }
  .vs__selected {
    width: 208px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

</style>
